import {
  Backdrop, Button, Card, CardActions, CardContent, CardHeader, Checkbox, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider,
  FormControl, Grid, Input, InputAdornment, LinearProgress, Slide, Slider, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography
} from '@material-ui/core';
import { SearchIcon } from '@material-ui/data-grid';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import CloseIcon from '@material-ui/icons/Close';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import QueueIcon from '@material-ui/icons/Queue';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { CustomTableCell } from 'src/components/CustomTableCell';
import GenericBulten from 'src/components/GenericBulletin';
import Page from 'src/components/Page';
import AddressSearch from 'src/components/Selects/AddressSearch';
import LockIcon from '@material-ui/icons/Lock';
import axios from 'src/utils/axios';
import {
  getSepetAdet, getUser,
  sc,

  setSepetAdet
} from 'src/utils/Common';


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  cardUstBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  container: {
    maxHeight: 497,
    minHeight: 497,
    mimWidth: 500
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  rootAdresSearch: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(0)
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Counting() {
  const classes = useStyles();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [LoadingMaterial, setLoadingMaterial] = React.useState(true);
  const [bultenOpen, setBultenOpen] = React.useState(false);
  const [bultenParam, setBultenParam] = React.useState('');
  const [openMaterialFileTitle, setOpenMaterialFileTitle] = React.useState('');
  const [openMaterialFile, setOpenMaterialFile] = React.useState(false);
  const [ImageUrl, setImageUrl] = useState(null);
  const [SiparisAdetTitle, setSiparisAdetTitle] = React.useState('');
  const [siparisAdet, setsiparisAdet] = React.useState(1);
  const [openSiparisAdet, setopenSiparisAdet] = React.useState(false);
  const [Loading, setLoading] = useState(false);
  const [MalzemeSiparis, setMalzemeSiparis] = React.useState('');
  const SessionUser = getUser();
  const [WarehouseAddress, setWarehouseAddress] = useState([]);
  const [SayimData, setSayimData] = useState([]);
  const [SayimDataMain, setSayimDataMain] = useState([]);
  const [previous, setPrevious] = React.useState({});
  const [selected, setSelected] = React.useState([]);
  const [SayimArama, setSayimArama] = React.useState("");
  const [MalzemeEkle, setMalzemeEkle] = React.useState("");
  const [Adresrow, setAdresrow] = useState([{ WarehouseAddress: 0, WarehouseAddressText: '', Malzemeleri: '' }]);

  const onChangeSelectWarehouse = (valueParam, nameParam, row) => {
    if (!previous[row.MALZEME_STOK_NO]) {
      setPrevious(state => ({ ...state, [row.MALZEME_STOK_NO]: row }));
    }
    const value = valueParam;
    const name = nameParam;

    const newRows = SayimData.map(item => {
      if (
        item.MALZEME_STOK_NO === row.MALZEME_STOK_NO &&
        item.FIS_NO === row.FIS_NO
      ) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setSayimData(newRows);
    setSayimDataMain(newRows);
  };
  const onChange = (e, row) => {
    console.log(row);
    if (!previous[row.ID]) {
      setPrevious(state => ({ ...state, [row.ID]: row }));
    }

    var value = e.target.value;
    const name = e.target.name;
    if (parseInt(value) < 0) {
      value = 1;
    }
    const newRows = SayimData.map(item => {
      if (item.MALZEME_STOK_NO === row.MALZEME_STOK_NO &&
        item.FIS_NO === row.FIS_NO
        && item.ID === row.ID
      ) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setLoading(true);
    var AdresId = row.WarehouseAddress;
    axios
      .get(`/SetMaterialCountingItemAdd/${row.MALZEME_STOK_NO}/${AdresId}/${SessionUser.ServiceShopId}/${SessionUser.OrganizationUserId}/${value}`)
      .then(response => {
        if (response.data.toString() === 'Basarili') {
          setMalzemeEkle("");
        } else {
          setUyariTip('error');
          setUyariAciklama(response.data);
          setUyari(true);
        }
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
    setSayimData(newRows);
    setSayimDataMain(newRows);
  };
  const handleCloseMaterialFile = () => {
    setOpenMaterialFile(false);
  };
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const handleCloseSiparisAdet = () => {
    setopenSiparisAdet(false);
    setsiparisAdet(1);
  };
  const handleSliderChange = (event, newValue) => {
    setsiparisAdet(newValue);
    if (Number(newValue) < 0) {
      setsiparisAdet(0);
    } else if (Number(newValue) > 999) {
      setsiparisAdet(999);
    }
  };
  const GetMaterialBulletin = (event, materialCode) => {
    setBultenParam(materialCode);
    setBultenOpen(true);
    setLoadingMaterial(false);
  };
  const handleInputChange = event => {
    setsiparisAdet(event.target.value === '' ? '' : Number(event.target.value));
    if (Number(event.target.value) < 0) {
      setsiparisAdet(0);
    } else if (Number(event.target.value) > 999) {
      setsiparisAdet(999);
    }
  };
  const handleBlur = () => {
    if (siparisAdet < 0) {
      setsiparisAdet(0);
    } else if (siparisAdet > 999) {
      setsiparisAdet(999);
    }
  };
  const SepeteEkleDetay = event => {
    setLoading(true);
    const data = {
      MALZEME_STOK_NO: MalzemeSiparis,
      BIRIM_KODU: SessionUser.ServiceShopId,
      TEKNISYEN_KODU: SessionUser.OrganizationUserId,
      ADET: siparisAdet
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetMaterialBasket', data, config)
      .then(response => {
        if (response.data[0].ErrorCode === '0') {
          var Deger = getSepetAdet();
          setSepetAdet(parseInt(Deger) + 1);
          setUyariTip('success');
          setUyariAciklama('İşlem başarılı');
          setUyari(true);

        } else {
          setUyariTip('error');
          setUyariAciklama(response.data[0].ErrorDescription);
          setUyari(true);
        }
        setLoading(false);
        setopenSiparisAdet(false);
        setsiparisAdet(1);
      })
      .catch(error => {
        setUyariTip('error');
        setUyariAciklama('Bir hata oluştu!..' + error.message);
        setUyari(true);
        setLoading(false);
      });
  };

  const SepeteEkle = (event, MALZEME_STOK_NO) => {
    setMalzemeSiparis(MALZEME_STOK_NO);
    setSiparisAdetTitle(
      MALZEME_STOK_NO +
      ' numaralı malzeme sipariş verebilmeniz için sepete eklenecektir!... Devam etmek istediğinizden emin misiniz?'
    );
    setopenSiparisAdet(true);
  };
  const GetMaterialImage = (event, materialCode) => {
    setOpenMaterialFile(true);
    setLoadingMaterial(true);
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    setOpenMaterialFileTitle(materialCode + ' Numaralı Malzeme Detayı');
    axios
      .get(`MaterialFile/${materialCode}`, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setImageUrl(fileURL);
        setLoadingMaterial(false);
      })
      .catch(error => {
        setLoadingMaterial(false);
      });
  };
  const SetMaterialDelete = (event, row, ID) => {
    confirmAlert({
      message:
        'Talepte bulunulan ' + row.MALZEME_STOK_NO +' ' + row.MALZEME +' malzeme siparişi iptal edilecektir!... Devam etmek istediğinizden emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            SetMaterialDeleteKabul(event, row, ID);
          }
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };
  const isSelected = name => selected.indexOf(name) !== -1;
  const SetMaterialDeleteKabul = (event, row, ID) => {
    setLoading(true);
    axios
      .get(`/SetMaterialCountingDelete/${ID}`)
      .then(response => {
        setLoading(false);
        var SayimDataParam = [...SayimData];
        var filteredIndex = SayimDataParam.findIndex(
          x => x.ID === ID
        );
        SayimDataParam.splice(filteredIndex, 1);
        setSayimData(SayimDataParam);
        setSayimDataMain(SayimDataParam);
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
        setSayimData([]);
        setSayimDataMain([]);
      });
  };

  const handleClick = (event, row, index) => {
    if (row.RowSelected === 0) {
      row.RowSelected = 1;
    } else {
      row.RowSelected = 0;
    }
    let SayimDataOld = [...SayimData];
    setSayimData(SayimDataOld);
    setSayimDataMain(SayimDataOld);
  };


  function onSorgula() {
    setLoading(true);
    axios
      .get(
        `/GetCountingMaterial/${SessionUser.ServiceShopId}`
      )
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setSayimData(response.data);
          setSayimDataMain(response.data);
        } else {
          setSayimData([]);
          setSayimDataMain([]);
        }
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
        setSayimData([]);
        setSayimDataMain([]);
      });
  }

  const setMaterialResetAccept = () => {
    setLoading(true);
    axios
      .get(
        `/SetMaterialReset/${SessionUser.ServiceShopId}/${SessionUser.OrganizationUserId}/${MalzemeEkle}`
      )
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {

        } else {

        }
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const setMaterialReset = () => {

    if (MalzemeEkle.length < 1){
      return;
    }


    confirmAlert({
      message: MalzemeEkle + " numaralı malzemeyi sıfırlamak isteğinizden emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => setMaterialResetAccept()
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });

  }


  const setFilter = (Param) => {
    setSayimArama(Param);
    setSayimData(SayimDataMain.filter(item => sc(item.MALZEME_STOK_NO, Param) || sc(item.MALZEME, Param) || sc(item.WarehouseAddressText, Param) || sc(item.KULLANICI, Param)))
  };

  const search = "";

  const setAdres = (param, index, MALZEME_STOK_NO) => {

    let old_rows = [...SayimData];
    old_rows[index].WarehouseAddress = param?.Id || 0;
    old_rows[index].WarehouseAddressText = param?.Description || 0;
    old_rows[index].Malzemeleri = param?.Materials || 0;
    setSayimData(old_rows);

  }
  const setAdresEkle = (param, index, MALZEME_STOK_NO) => {
    let old_rows = [...Adresrow];
    console.log(old_rows);
    old_rows[0].WarehouseAddress = param?.Id || 0;
    old_rows[0].WarehouseAddressText = param?.Description || 0;
    old_rows[0].Malzemeleri = param?.Materials || 0;
    console.log(old_rows);
    setAdresrow(old_rows);
  }

  const MalzemeSayimEkle = () => {





    setLoading(true);
    var AdresId = Adresrow[0].WarehouseAddress;
    axios
      .get(`/SetMaterialCountingAdd/${MalzemeEkle}/${AdresId}/${SessionUser.ServiceShopId}/${SessionUser.OrganizationUserId}`)
      .then(response => {
        if (response.data.toString() === 'Basarili') {
          onSorgula();
          setMalzemeEkle("");
        } else {
          setUyariTip('error');
          setUyariAciklama(response.data);
          setUyari(true);
        }
        setLoading(false);
      })
      .catch(error => {
        onSorgula();
        setLoading(false);
      });
  };

  const CikisYapDetay = (event, tip) => {
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    const SendData = SayimData.filter(
      d => parseInt(d.RowSelected) === parseInt(1)
    );
    const data = SendData.map(item => ({
      ServiceShopId: SessionUser.ServiceShopId,
      ID: item.ID,
      MaterialId: item.MALZEME_KODU,
      Count: item.Count,
      WarehouseAddress: item.WarehouseAddress,
      UserId: SessionUser.OrganizationUserId,
      Type: tip,
      DEPO_ADET: item.DEPO_ADET,
      ADRES_ADET: item.ADRES_ADET
    }));
    axios
      .post('/SetCountingSendtoCenter', data, config)
      .then(response => {
        setLoading(false);
        setUyariTip('success');
        onSorgula();
        let ResponseData = response.data[0];
        setUyariAciklama(ResponseData.ErrorDescription);
        setUyari(true);
      });
  };

  const CikisYap = (event, tip) => {
    if (
      SayimData.filter(d => parseInt(d.RowSelected) === parseInt(1))
        .length === 0
    ) {
      setUyariTip('error');
      setUyariAciklama('Seçim yapmadınız!... Lütfen önce seçim yapınız!...');
      setUyari(true);
      return;
    }

    var Uyari = "";
    if (tip === 1) {
      Uyari = "Seçili olan sayımlarınız iptal edilecektir!... Devam etmek istediğinizden eminmisiniz?"
    } else {
      Uyari = "Seçili olan sayımlarınız onaylanacaktır!... Devam etmek istediğinizden eminmisiniz?"
    }

    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => CikisYapDetay(event, tip)
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="oasis Yönetimi Sayım İşlemleri" />
          <Divider />
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar open={uyari} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyariTip}>
              {uyariAciklama || ''}
            </Alert>
          </Snackbar>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <Card className={classes.cardUstBolum}>
                  <CardHeader
                    title="İşlemler"
                    action={
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={4}>
                          <Button
                            variant="contained"
                            className={classes.button}
                            // color="secondary"
                            style={{ backgroundColor: 'red', color: 'white' }}
                            endIcon={<ThumbDownIcon></ThumbDownIcon>}
                            onClick={event => CikisYap(event, 1)}
                          >
                            Reddet
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Button
                            variant="contained"
                            className={classes.button}
                            // color="secondary"
                            style={{ backgroundColor: 'green', color: 'white' }}
                            endIcon={<ThumbUpIcon></ThumbUpIcon>}
                            onClick={event => CikisYap(event, 2)}
                          >
                            Onayla
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Button
                            variant="contained"
                            className={classes.button}
                            color="secondary"
                            endIcon={<SearchIcon></SearchIcon>}
                            onClick={onSorgula}
                          >
                            Sorgula
                          </Button>
                        </Grid>
                      </Grid>
                    }
                  />
                  <Divider />
                  <CardActions>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={2}>
                        <FormControl fullWidth className={classes.rootAdresSearch}>
                          <AddressSearch
                            setAdres={setAdresEkle}
                            value={{
                              Id: Adresrow[0].WarehouseAddress || '0',
                              Description: Adresrow[0].WarehouseAddressText || 'Adres Seçiniz!...',
                              Materials: Adresrow[0].Malzemeleri | ''
                            } || ''}
                            searchParam={search}
                            // MaterialCode={row.materialCode}
                            ServicePaperNr={0}
                            index={1}
                            Adres={Adresrow[0].WarehouseAddress || 0}
                            RowSelected={1}
                            Tip={"Giris"}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          label={'Stok No'}
                          fullWidth
                          className={clsx(classes.margin, classes.textField)}
                          value={MalzemeEkle}
                          onChange={event => { setMalzemeEkle(event.target.value) }}
                          onKeyPress={event => {
                            if (event.key === 'Enter') {
                              MalzemeSayimEkle()
                            }
                          }}
                          InputProps={{
                            endAdornment:
                              <InputAdornment position="end">
                                <QueueIcon
                                  onClick={(event) => MalzemeSayimEkle()}
                                  color="primary"
                                />
                              </InputAdornment>,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={1}>

                      </Grid>
                      <Grid item xs={12} sm={2}>
                      
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <FormControl fullWidth className={classes.margin}>
                          <TextField
                            label="Arama Yapınız..."
                            value={SayimArama}
                            name={SayimArama}
                            className={clsx(classes.margin, classes.textField)}
                            onChange={event => { setFilter(event.target.value) }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <SearchIcon />
                                </InputAdornment>
                              )
                            }}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </CardActions>
                  <Divider />
                  <CardContent>
                    <TableContainer className={classes.container}>
                      <Table
                        className={classes.table}
                        size="small"
                        stickyHeader
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell padding='none' align="left">Seçim</TableCell>
                            <TableCell padding='none' align="left">Durum</TableCell>
                            <TableCell padding='none' align="left">MalzemeStokNo</TableCell>
                            <TableCell padding='none' align="left">Malzeme</TableCell>
                            <TableCell padding='none' align="left">DepoAdet</TableCell>
                            <TableCell padding='none' align="left">AdresAdet</TableCell>
                            <TableCell padding='none' align="center">SayımAdet</TableCell>
                            <TableCell padding='none' align="center" width="200">
                              Adres
                            </TableCell>
                            <TableCell padding='none' align="center">Kullanıcı</TableCell>
                            <TableCell padding='none' align="center">Tarih</TableCell>
                            <TableCell padding='none' align="center">Resim</TableCell>
                            <TableCell padding='none' align="center">Bülten</TableCell>
                            <TableCell padding='none' align="center">Sil</TableCell>
                            <TableCell padding='none' align="center">Sipariş</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {SayimData.sort(
                            (
                              { isEditMode: previousID },
                              { isEditMode: currentID }
                            ) => previousID - currentID
                          )
                            // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                              const isItemSelected = isSelected(index);
                              const labelId = `enhanced-table-checkbox-${index}`;
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  aria-checked={isItemSelected}
                                  tabIndex={-1}
                                  key={index}
                                  selected={isItemSelected}
                                >
                                  <TableCell padding="checkbox">
                                    <Checkbox
                                      onClick={event =>
                                        handleClick(event, row, index)
                                      }
                                      checked={row.RowSelected}
                                      color="primary"
                                      inputProps={{
                                        'aria-labelledby': labelId
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.DURUM}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.MALZEME_STOK_NO}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    title={row.MALZEME}
                                    className={classes.tableCell}
                                  >
                                    {row.MALZEME}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.DEPO_ADET}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.ADRES_ADET}
                                  </TableCell>
                                  {row.RowSelected === 1 ? (
                                    <CustomTableCell
                                      {...{ row, name: 'Count', onChange, Adet: parseInt(row.ADRES_ADET, 10) }}
                                    />
                                  ) : (
                                    <TableCell
                                      align="center"
                                      padding='none'
                                      className={classes.tableCell}
                                    >
                                      <TextField
                                        type="number"
                                        disabled
                                        value={row.Count}
                                        inputProps={{
                                          min: 0,
                                          style: { textAlign: 'center' }
                                        }}
                                        style={{ width: 80 }}
                                      />
                                    </TableCell>
                                  )}
                                  <TableCell padding='none' align="center">
                                    {row.WarehouseAddressText}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.KULLANICI}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.TARIH}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    <ImageSearchIcon
                                      onClick={event =>
                                        GetMaterialImage(
                                          event,
                                          row.MALZEME_STOK_NO
                                        )
                                      }
                                      color="primary"
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    <FindInPageIcon
                                      onClick={event =>
                                        GetMaterialBulletin(
                                          event,
                                          row.MALZEME_STOK_NO
                                        )
                                      }
                                      color="primary"
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.ID === 0 ? (
                                      ''
                                    ) : (
                                      <DeleteForeverIcon
                                        onClick={event =>
                                          SetMaterialDelete(event, row, row.ID)
                                        }
                                        color="primary"
                                      />
                                    )}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                     {row.SIP_VERILEBILIR === 0 ?
                                      <LockIcon color="error" />
                                      :
                                      <AddShoppingCartIcon
                                        onClick={(event) => SepeteEkle(event, row.MALZEME_STOK_NO)}
                                        color="primary"
                                      />
                                    }
                                   
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={bultenOpen}
        onClose={() => setBultenOpen(false)}
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle id="alert-dialog-title">
          Malzemeye Ait Bültenler
        </DialogTitle>
        <DialogContent>
          {LoadingMaterial ? (
            <LinearProgress status="loading" />
          ) : (
            <GenericBulten param={bultenParam} />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setBultenOpen(false)}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openMaterialFile}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseMaterialFile}
      >
        <DialogTitle>{openMaterialFileTitle}</DialogTitle>
        <DialogContent>
          {LoadingMaterial ? (
            <LinearProgress status="loading" />
          ) : (
            <img style={{ width: '100%' }} alt="" src={ImageUrl} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMaterialFile} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSiparisAdet}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseSiparisAdet}
      >
        <DialogTitle>{SiparisAdetTitle}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Typography id="input-slider" gutterBottom>
              Sipariş Adet
            </Typography>
            <Grid item xs={12} sm={12}>
              <Slider
                value={typeof siparisAdet === 'number' ? siparisAdet : 0}
                onChange={handleSliderChange}
                aria-labelledby="input-slider"
                max={999}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Input
                className={classes.input}
                value={siparisAdet}
                margin="dense"
                fullWidth
                onChange={handleInputChange}
                onBlur={handleBlur}
                inputProps={{
                  step: 10,
                  min: 0,
                  max: 100,
                  type: 'number',
                  'aria-labelledby': 'input-slider'
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={SepeteEkleDetay} color="primary">
            Ekle
          </Button>
          <Button onClick={handleCloseSiparisAdet} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default Counting;
